var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"monerisCheckout"}},[_c('v-alert',{attrs:{"type":_vm.alertType},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(_vm._s(_vm.alertMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }